const quickHttpApi = async (url, body) => {

    // http://localhost:3000
    // https://picfinder.dev/api
    const res = await fetch(
        url,
        // "https://picfinder.dev/api",
        {
            method: "POST",
            credentials: "include",
            // credentials: (useCredentialsSameOrigin) ? "same-origin" : "include",
            ...body != null ? {
                body: JSON.stringify(body),
                headers: {
                    "Accept": "application/json",
                    "content-type": "application/json",
                    // ...headers,
                },
            } : {
                // headers: {...headers},
            },
            // ...options,
        },
    );
    if (!res.headers.get("exception")) {
        // console.log(url, [...res.headers.entries()]);
        const contentLength = res.headers.get("Content-Length");
        if (contentLength === "0") {
            return null;
        }
        return await res.json();
    } else {
        throw await res.json();
    }
};
exports.quickHttpApi = quickHttpApi;
exports.quickClientApi = quickHttpApi;


const QuickHttpApiProxy = ({host}={}) => new Proxy({}, {
    get: (_, methodName) => async (params) => {
        return await quickHttpApi((host ?? "") + "/api/" + methodName, params);
    },
});
exports.QuickHttpApiProxy = QuickHttpApiProxy;
exports.QuickClientApiProxy = QuickHttpApiProxy;

